<template>
  <a v-if="mac_sys_url" :href="mac_sys_url" download="AC" class="downLoad">AC</a>
</template>

<script>
import { isMac } from '@js'
import { mapGetters } from 'vuex'

export default {
  props: {
    isCheck: {
      default: false,
      required: false,
      isMac: false,
      isWindows: false
    }
  },
  computed: {
    ...mapGetters(['_acDownloadUrl']),
    //判断电脑是mac还是windows
    mac_sys_url() {
      if (this._acDownloadUrl.mac && this._acDownloadUrl.pc) {
        let _isMac = isMac()
        return this._acDownloadUrl[_isMac ? 'mac' : 'pc']
      }
    }
  }
}
</script>
<style lang='less'>
.downLoad {
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  width: 75px;
  height: 75px;
  text-align: center;
  padding-top: 52px;
  background: url('~@img/donwload_icons.png') no-repeat center
    10px;
  box-shadow: 0 0 2px 2px #ecebec;
  border-radius: 5px;
  z-index: 99;
  &.mypage_icon {
    background-image: url('~@img/mypage_icons.png');
  }
  &:hover {
    border: 1px solid #fcc800;
  }
}
</style>


// WEBPACK FOOTER //
// ac.vue?129294f1